// react
import { useState } from 'react';
import { translateTransactionType } from '../../../utils/translations';

// types
import { LoadingStatus, Transaction } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions, DialogActionsProps } from '../DialogActions/DialogActions';

// forms
import { FormAddWithdrawalApplication } from '../../forms/FormAddWithdrawalApplication/FormAddWithdrawalApplication';

// props
export interface DialogAddWithdrawalApplicationProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
	transaction?: Transaction;
}

export const DialogAddWithdrawalApplication = ({
	isOpen,
	onClose,
	onSuccess,
	transaction,
}: DialogAddWithdrawalApplicationProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [status, setStatus] = useState<LoadingStatus>('DEFAULT');

	// vars
	const idForm = 'form-add-withdrawal-application';

	const subtitle: DialogActionsProps['subtitle'] = transaction
		? {
				children: `${translateTransactionType(transaction.type, t)} ${transaction.id}`,
			}
		: undefined;

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('initiateWithdrawalApplication'),
					form: idForm,
					loading: status === 'LOADING',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			onClose={onClose}
			subtitle={subtitle}
			title={{
				children: t('initiateWithdrawalApplication'),
				variant: 'h3',
			}}>
			<FormAddWithdrawalApplication
				idForm={idForm}
				isOpen={isOpen}
				onClose={onClose}
				onSuccess={onSuccess}
				setStatus={setStatus}
				transaction={transaction}
			/>
		</DialogActions>
	);
};
